import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import { type FC, useCallback } from "react";
import { useMemo } from "react";

import { useFiltersScope } from "~/components/filters/FiltersScope";
import { FilterDropdownMultiple } from "~/components/UI/FilterDropdown";
import type { PlatformEnum } from "~/types/platform";

import { platformFilterOptions } from "./constants";

interface IPlatformFilterProps {
  minOptionCount?: number;
  platforms?: string[];
}

export const PlatformFilter: FC<IPlatformFilterProps> = ({
  minOptionCount = 1,
  platforms,
}) => {
  const { filters, updateFilters } = useFiltersScope();

  const onChange = useCallback(
    (platforms?: PlatformEnum[]) => {
      updateFilters({ platforms });
    },
    [updateFilters]
  );

  const filterOptions = useMemo(() => {
    if (platforms?.length) {
      return platformFilterOptions.filter(({ value }) =>
        platforms.includes(value)
      );
    }
    return platformFilterOptions;
  }, [platforms]);

  return (
    <FilterDropdownMultiple
      label="Platform"
      icon={<HubOutlinedIcon fontSize="inherit" />}
      options={filterOptions}
      value={filters.platforms ?? []}
      onChange={onChange}
      minOptionCount={minOptionCount}
    />
  );
};
